export default class Subscription {
  constructor(dom) {
    this.dom = dom;
    this.btnSubmit = this.dom.querySelector('button[type="submit"]');
    this.emailField = this.dom.querySelector('input[type="email"]');
  }
  init() {
    this.btnSubmit.addEventListener("click", async (e) => {
      e.preventDefault();
      this.emailField.setAttribute("disabled", true);
      this.btnSubmit.classList.add("disabled");
      let result = await this.handleSubmission();
      this.handleResult(result);
    });
  }

  async handleSubmission() {
    //some async function
    return false;
  }

  handleResult(successful) {
    if (successful == true) {
      this.emailField.value = "Subscription Successful"; //dummy response message
    } else {
      this.emailField.classList.add("has-error");
      this.emailField.value = "Invalid email address"; //dummy response message
    }
    setTimeout(() => {
      this.btnSubmit.classList.remove("disabled");
      this.emailField.removeAttribute("disabled");
      this.emailField.classList.remove("has-error");
      this.emailField.value = "";
    }, 3000);
  }
}
